import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatDateTime } from '../../../../util/datetime'
import ToggleButton from '../../../form/component/ToggleButton'
import currentUserHasAccess from '../../../../util/widget-helper'
import { SHIPMENT_LIST_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const DHL_TRACKING_URL = 'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode='

const FinalStatus = ({ status }) => {
    if (!status) {
        return (<span>in delivery</span>)
    }
    return (<span>{status.replace(/_/g, ' ')}</span>)
}

const DHLTrackingLink = ({ shipmentId }) => {
    if (!shipmentId) {
        return null
    }

    return (<a href={DHL_TRACKING_URL + shipmentId} target="_blank" rel="noopener noreferrer">{shipmentId}<i className="fa fa-external-link"/></a>)
}

const LabelUrl = ({ labelURL }) => {
    if (!labelURL) {
        return null
    }
    return <a href={labelURL} target="_blank" rel="noopener noreferrer">view</a>
}

const ShipmentDetail = ({ shipment, toggleShipmentTracking, shipmentDetailOpen }) => {
    return (
        <tr>
            <td>{formatDateTime(shipment.created)}</td>
            <td><DHLTrackingLink shipmentId={shipment.externalShipmentId}/></td>
            <td><DHLTrackingLink shipmentId={shipment.externalReturnShipmentId}/></td>
            <td>{shipment.shipmentProvider}</td>
            <td><FinalStatus status={shipment.finalState}/></td>
            <td><LabelUrl labelURL={shipment.labelURL}/></td>
            <td><LabelUrl labelURL={shipment.returnLabelURL}/></td>
            <td className="align-center">
                <ToggleButton
                    toggle={() => {
                        toggleShipmentTracking(shipment.id)
                    }}
                    active={!!shipmentDetailOpen[shipment.id]}
                    activeIcon="fa fa-search-minus"
                    inactiveIcon="fa fa-search-plus"/>
            </td>
        </tr>)
}

const TrackingDetail = ({ shipment }) => {
    return (
        <tr>
            <td colSpan={7}>
                <table>
                    <tbody>
                        {shipment.shipmentEventList && shipment.shipmentEventList.map(tracking => {
                            return (
                                <tr key={tracking.timestamp}>
                                    <td>{tracking.timestamp}</td>
                                    <td dangerouslySetInnerHTML={{ __html: tracking.eventText }}/>
                                </tr>)
                        })}
                    </tbody>
                </table>
                {shipment.returnShipmentEventList && (
                    <div>
                        <span>Return tracking</span>
                        <table>
                            <tbody>
                                {shipment.returnShipmentEventList && shipment.returnShipmentEventList.map(tracking => {
                                    return (
                                        <tr key={tracking.timestamp}>
                                            <td>{tracking.timestamp}</td>
                                            <td>{tracking.eventText}</td>
                                        </tr>)
                                })}
                            </tbody>
                        </table>

                    </div>
                )}

            </td>
        </tr>
    )
}


const Shipment = ({ shipment, shipmentDetailOpen, toggleShipmentTracking }) => {
    const rowList = [<ShipmentDetail key={shipment.id + 's'} shipment={shipment} shipmentDetailOpen={shipmentDetailOpen} toggleShipmentTracking={toggleShipmentTracking}/>]

    if (shipmentDetailOpen[shipment.id]) {
        rowList.push(<TrackingDetail key={shipment.id + 't'} shipment={shipment}/>)
    }
    return rowList
}

const AddShipment = ({ salesOrder, addShipment, createShipment, fetching }) => {
    if (!salesOrder || !addShipment || !salesOrder.salesOrderCustomer) {
        return null
    }
    return (
        <Row>
            <Column>
                <button
                    onClick={() => {
                        createShipment(salesOrder.id, addShipment)
                    }}
                    disabled={fetching}
                    className="btn btn-warning btn-sm">
                    create Shipment
                </button>
            </Column>
        </Row>
    )
}


const ShipmentList = ({ shipmentList, salesOrder, addShipment, createShipment, fetching, shipmentDetailOpen, toggleShipmentTracking }) => {
    if (!currentUserHasAccess(SHIPMENT_LIST_WIDGET_CONTAINER)) {
        return null
    }

    return (
        <ContentBox title="Shipment">
            <AddShipment
                fetching={fetching}
                salesOrder={salesOrder}
                addShipment={addShipment}
                createShipment={createShipment}
            />
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Created</th>
                                <th>Tracking</th>
                                <th>Tracking (return)</th>
                                <th>Provider</th>
                                <th>Status</th>
                                <th>Label</th>
                                <th>Return Label</th>
                                <th>Tracking</th>
                            </tr>
                        </thead>
                        <tbody>
                            {shipmentList.map(shipment => {
                                return (<Shipment
                                    toggleShipmentTracking={toggleShipmentTracking}
                                    shipmentDetailOpen={shipmentDetailOpen}
                                    key={shipment.id}
                                    shipment={shipment}/>)
                            })}

                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

ShipmentList.propTypes = {
    shipmentList: PropTypes.array.isRequired,
    addShipment: PropTypes.func,
    createShipment: PropTypes.func,
    salesOrder: PropTypes.object,
    fetching: PropTypes.bool.isRequired,
}

export default ShipmentList




// WEBPACK FOOTER //
// ./src/modules/logistic/component/list/ShipmentList.js